import {useCallback} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {recheckOnlineStatus} from './useIsOffline';

const APP_LOAD_QUERY_KEYS = [
  QUERY_CACHE_KEYS.apiClient,
  QUERY_CACHE_KEYS.reservation,
  QUERY_CACHE_KEYS.summary,
  QUERY_CACHE_KEYS.template,
];

function useRetryAppLoad() {
  const queryClient = useQueryClient();

  return useCallback(() => {
    recheckOnlineStatus();
    for (const key of APP_LOAD_QUERY_KEYS) {
      void queryClient.invalidateQueries({queryKey: [key]});
    }
  }, [queryClient]);
}

export {useRetryAppLoad};
